import type { BillingCurrency } from '@contracts/payment/Currency';
import { TransactionCurrency } from '@contracts/payment/Currency';
import type { BillingRow } from '@src/orders/domain/Billing';
import { CurrencyCell } from '@src/orders/review/CurrencyCell';
import { BorderedTableCell, WideRow } from '@src/orders/review/StyledTableRows';
import { useTranslation } from 'react-i18next';

interface Props {
  currency: BillingCurrency;
  totals: BillingRow;
}

export const LineOfCreditTotalRow = ({ currency, totals }: Props) => {
  const { t } = useTranslation();

  return (
    <WideRow selected>
      <BorderedTableCell variant="head" align="right">
        {t('reviewBilling.totalBillable')}
      </BorderedTableCell>
      <CurrencyCell
        cellCurrency={TransactionCurrency.CAD}
        currency={currency}
        value={totals.CAD}
        prefix
      />
      <CurrencyCell
        cellCurrency={TransactionCurrency.USD}
        currency={currency}
        value={totals.USD}
        prefix
      />
    </WideRow>
  );
};
